<template>
  <transition-group name='fade'>
    <!-- 蒙版 -->
    <div class="mask"
         key="1"
         @click="show = false"
         v-if="show"
         @touchmove.prevent>
    </div>
    <div class="pop"
         v-show="show"
         key="2">
        <div class="nameBox">
          <div class="main" v-if="content.length > 1">
            <div class="item" style="overflow: hidden;height: 20px;white-space: nowrap;text-overflow: ellipsis">{{content[0]}}</div>
            <div class="item" style="overflow: hidden;height: 20px;white-space: nowrap;text-overflow: ellipsis">{{content[1]}}</div>
          </div>
          <div v-else>
            <div style="width: 215px; overflow: hidden;height: 20px;white-space: nowrap;text-overflow: ellipsis">{{content[0]}}</div>
          </div>
        </div>
        <div class="img_box">
<!--              两个-->
            <div class="mainImg" v-if="imgUrl.length > 1">
<!--              <div class="img"></div>-->
<!--              <div class="img"></div>-->
              <img :src="imgUrl[0]" alt="" class="img">
              <img :src="imgUrl[1]" alt="" class="img">
            </div>
<!--          一个-->
            <div class="mainImg" style="justify-content: center" v-else>
                <img :src="imgUrl[0]" alt="" class="img">
<!--              <div class="img">-->
<!--                <img src="" alt="">-->
<!--              </div>-->
<!--              <div class="img"></div>-->
            </div>
        </div>
        <div class="btnbox cursor">
          <div class="btn" @click="btnClick">前往查看</div>
        </div>
      <img @click="show = false"
           class="close cursor"
           src="https://img.webloom.cn/coach/ui/common_close_white.png"
           alt="">
    </div>
  </transition-group>

</template>

<script>
export default {
  name: 'Popup',
  data () {
    return {
      show: false,
      imgUrl: '',
      title: '',
      content: '',
      btnText: ''
    }
  },
  created () {},
  methods: {
    btnClick () {
      this.click()
      this.show = false
    }
  }
}
</script>

<style lang="scss" scoped>
// 渐变过渡
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.35s;
}
// 全局弹窗
.mask {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
}
.pop {
  height: 600px;
  width: 690px;
  background: #fff;
  border-radius: 16px;
  position: fixed;
  top: 100px;
  left: 50%;
  margin-left: -345px;
  z-index: 20;
  text-align: center;
  background-image: url("https://img.webloom.cn/coach/ui/img_congratulation.png");
  .nameBox{
    margin-top: 128px;
    font-family: MicrosoftYaHeiUI-Bold;
    font-size: 20px;
    color: #FBD783;
    letter-spacing: 0;
    text-align: center;
    display: flex;
    justify-content: center;
    .main{
      width: 455px;
      display: flex;
      justify-content: space-between;
      .item {
        width: 215px;
      }
    }
  }
  .img_box{
    margin-top: 15px;
    height: 304px;
    display: flex;
    justify-content: center;
    .mainImg{
      display: flex;
      justify-content: space-between;
      width: 455px;
      .img{
        height: 304px;
        width: 215px;
        background: #FFFFFF;
      }
    }
  }
  .btnbox{
    display: flex;
    justify-content: center;
    .btn{
      border: 2px solid #FBD783;
      border-radius: 8px;
      width: 120px;
      height: 40px;
      line-height: 40px;
      font-family: MicrosoftYaHeiUI-Bold;
      font-size: 14px;
      color: #FBD783;
      letter-spacing: 0;
      text-align: center;
      margin-top: 20px;
    }
  }
  button {
    background: #f95644;
    border-radius: 32px;
    width: 180px;
    height: 50px;
    font-size: 18px;
    color: #ffffff;
  }
  .close {
    top: -50px;
    right: 0px;
    position: absolute;
    display: block;
    width: 32px;
    height: 32px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/popup/index.vue